import RouteBase from '@/router/routes/RouteBase.js';
import { PM_AKADEMI } from '@/constants/urls.constants';

class RoutesSecure {
  subFolderPath = '';
  isPublic = false;

  Feed = new RouteBase({
    name: 'feed',
    path: 'feed',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Feed',
    pageTitle: 'Ana Sayfa',
    isPublic: this.isPublic,
    meta: {
      startupConfig: {
        setCustomerDetail: true,
      },
    },
  });

  Certificates = new RouteBase({
    name: 'certificates',
    path: 'certificates',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Certificates',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Sertifikalar',
        },
      ],
    },
  });

  FeedDetail = new RouteBase({
    name: 'feed-detail',
    path: 'feed/:id',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'FeedDetail',
    isPublic: this.isPublic,
  });

  PlayAndWin = new RouteBase({
    name: 'play-and-win',
    path: 'play-and-win',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'PlayAndWin',
    isPublic: this.isPublic,
    screenCode: 1,
    meta: {
      icon: 'cup',
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Oyna Kazan',
        },
      ],
    },
  });

  DoAndWin = new RouteBase({
    name: 'do-and-win',
    path: 'do-and-win',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'DoAndWin',
    isPublic: this.isPublic,
    screenCode: 2,
    meta: {
      icon: 'wave',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Yap Kazan',
        },
      ],
    },
  });

  Settings = new RouteBase({
    name: 'settings',
    path: 'settings',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Settings',
    isPublic: this.isPublic,
    screenCode: 10,
    meta: {
      icon: 'cog',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ayarlar',
        },
      ],
    },
  });
  Statics = new RouteBase({
    name: 'statics',
    path: 'statics',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Statics',
    isPublic: this.isPublic,
  });

  BusinessPartners = new RouteBase({
    name: 'business-partners',
    path: 'business-partners',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'BusinessPartners',
    isPublic: this.isPublic,
    meta: {
      icon: 'briefcase',
    },
  });

  ManageMyBusiness = new RouteBase({
    name: 'manage-my-business',
    path: 'manage-my-business',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'ManageMyBusiness',
    isPublic: this.isPublic,
    screenCode: 3,
    meta: {
      icon: 'briefcase',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Performans Takibi',
      },
    },
  });

  Surveys = new RouteBase({
    name: 'surveys',
    path: 'surveys',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Surveys',
    isPublic: this.isPublic,
    screenCode: 222,
    meta: {
      icon: 'wave',
      appbarConfig: { hasBackButton: false, title: 'Anketler' },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Anketler',
        },
      ],
    },
  });

  MyWallets = new RouteBase({
    name: 'my-wallets',
    path: 'my-wallets',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'MyWallets',
    isPublic: this.isPublic,
    screenCode: 4,
    meta: {
      icon: 'wallet',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Cüzdanlarım',
      },
      startupConfig: {
        setCustomerDetail: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Cüzdanlarım',
          link: '/secure/my-wallets',
        },
      ],
    },
  });

  Learn = new RouteBase({
    name: 'learn',
    path: 'learn',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Learn',
    isPublic: this.isPublic,
    screenCode: 5,
    meta: {
      icon: 'pieChart',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Öğren',
          link: '/secure/learn',
        },
      ],
    },
  });
  Fun = new RouteBase({
    name: 'fun',
    path: 'fun',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Fun',
    pageTitle: 'Yaşam',
    isPublic: this.isPublic,
    screenCode: 6,
    meta: {
      icon: 'magicStick',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Yaşam',
        hasSearchBar: true,
        collapsedHeight: 160,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Yaşam',
        },
      ],
    },
  });

  GiftCatalogue = new RouteBase({
    name: 'gift-catalogue',
    path: 'gift-catalogue',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'GiftCatalogue',
    isPublic: this.isPublic,
    screenCode: 7,
    meta: {
      icon: 'userGuide',
    },
  });

  Campaigns = new RouteBase({
    name: 'campaigns',
    path: 'campaigns',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Campaigns',
    isPublic: this.isPublic,
    screenCode: 8,
    meta: {
      icon: 'tag',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Kampanyalar',
        },
      ],
    },
  });

  CampaignDetail = new RouteBase({
    name: 'campaign-detail',
    path: 'campaigns/:id',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'CampaignDetail',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Kampanyalar',
          link: '/secure/campaigns',
        },
        {
          name: 'Kampanya Detay',
        },
      ],
    },
  });

  UserManual = new RouteBase({
    name: 'user-manual',
    path: 'user-manual',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'UserManual',
    isPublic: this.isPublic,
    screenCode: 9,
    meta: {
      icon: 'info',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Kullanım Kılavuzu',
        },
      ],
    },
  });

  VirtualVisit = new RouteBase({
    name: 'virtual-visit',
    path: 'virtual-visit',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'VirtualVisit',
    isPublic: this.isPublic,
    screenCode: 18,
    meta: {
      icon: 'virtualVisitMenu',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Şef Dükkanında',
        },
      ],
    },
  });

  ImageRecognition = new RouteBase({
    name: 'image-recognition',
    path: 'image-recognition',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'ImageRecognition',
    isPublic: this.isPublic,
    meta: {
      icon: 'wave',
      appbarConfig: {
        hasBackButton: false,
        title: 'Merhaba ',
      },
    },
  });
  Otp = new RouteBase({
    name: 'otp',
    path: 'tutun-akademi',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Otp',
    isPublic: this.isPublic,
    screenCode: 22,
    meta: {
      icon: 'otp',
      appbarConfig: {
        hasBackButton: false,
      },
    },
  });

  Legend = new RouteBase({
    name: 'legend',
    path: 'incelikte-marlboro-cagi',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Legend',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'İncelikte Marlboro Çağı',
        },
      ],
    },
  });

  Entrepreneurship = new RouteBase({
    name: 'entrepreneurship',
    path: 'entrepreneurship',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Entrepreneurship',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Entrepreneurship',
        },
      ],
    },
  });

  PmAkademi = new RouteBase({
    name: 'pm-akademi',
    path: 'pm-akademi',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'PmAkademi',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: PM_AKADEMI.DEFAULT_TITLE,
        },
      ],
    },
  });

  ContactGeneral = new RouteBase({
    name: 'contact',
    path: 'geribildirim',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Contact',
    isPublic: this.isPublic,
    screenCode: 21,
    meta: {
      icon: 'contact',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Ürün Geri Bidirimi',
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ürün Geri Bidirimi',
        },
      ],
    },
  });
  Player = new RouteBase({
    name: 'player',
    path: 'player',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Player',
    isPublic: this.isPublic,
    meta: {
      icon: 'info',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Video Player',
        },
      ],
    },
  });
  Playable = new RouteBase({
    name: 'playable',
    path: 'playable',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Playable',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Playable',
        },
      ],
    },
  });

  Chatbot = new RouteBase({
    name: 'chatbot',
    path: 'sef-cevaplasin',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Chatbot',
    isPublic: this.isPublic,
    screenCode: 23,
    meta: {
      icon: 'headphoneChef',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Sen Sor Şef Cevaplasın',
        },
      ],
    },
  });
  BeyondTime = new RouteBase({
    name: 'beyondtime',
    path: 'beyond-time',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'BeyondTime',
    isPublic: this.isPublic,
    screenCode: 25,
    meta: {
      icon: 'iconBeyondTime',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Zamanın Ötesinde',
        },
      ],
    },
  });

  MyAgreements = new RouteBase({
    name: 'agreements',
    path: 'agreements',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'MyAgreements',
    isPublic: this.isPublic,
    screenCode: 24,
    meta: {
      icon: 'iconAgreement',
      appbarConfig: { hasBackButton: true, title: 'Puan Kriterlerim' },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Puan Kriterlerim',
          link: '/secure/agreements',
        },
      ],
    },
  });
  MySurveys = new RouteBase({
    name: 'all-my-surveys',
    path: 'my-surveys',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'MySurveys',
    isPublic: this.isPublic,
    screenCode: 27,
    meta: {
      icon: 'iconSurvey',
      appbarConfig: { hasBackButton: true, title: 'Tüm Anketler' },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Tüm Anketler',
          link: '/secure/my-surveys',
        },
      ],
    },
  });

  Trendyol = new RouteBase({
    name: 'trendyol',
    path: 'trendyol',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Trendyol',
    isPublic: this.isPublic,
    screenCode: 26,
    meta: {
      icon: 'iconTrendyol',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Trendyol Cüzdan',
        },
      ],
    },
  });
  TrendyolPlayer = new RouteBase({
    name: 'trendyol-player',
    path: 'trendyol-player',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'TrendyolPlayer',
    isPublic: this.isPublic,
    meta: {
      icon: 'iconTrendyol',
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Trendyol Video',
        },
      ],
    },
  });

  EmergencyTrainings = new RouteBase({
    name: 'emergency-trainings',
    path: 'emergency-trainings',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'EmergencyTrainings',
    pageTitle: 'Emergency Trainings',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Emergency Trainings',
        },
      ],
    },
  });

  WeeklyPlayable = new RouteBase({
    name: 'weekly-playable',
    path: 'weekly-playable',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'WeeklyPlayable',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: true },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'WeeklyPlayable',
        },
      ],
    },
  });

  VideoSeries = new RouteBase({
    name: 'video-series',
    path: 'video-series',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'VideoSeries',
    pageTitle: 'Video Serileri',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Video Serileri',
        },
      ],
    },
  });

  PreOrderRedirect = new RouteBase({
    name: 'preorder-redirect',
    path: 'preorder-redirect',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'PreOrderRedirect',
    pageTitle: 'Ön-Sipariş Yönlendirme',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: { isCollapsable: false, hasBackButton: false },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ön-Sipariş Yönlendirme',
        },
      ],
    },
  });

  NotFound = new RouteBase({
    name: 'not-found-secure',
    path: '*',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'NotFound',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {},
    },
  });
}

export default new RoutesSecure();
